<template>
  <v-form>
    <v-container px-3 pb-0 class="blue-grey lighten-5">
      <div class="pb-3 body-2">Name your campaign in a way that makes sense to you.</div>
      <v-text-field
        required
        name="campaignName"
        label="Campaign Name"
        data-vv-as="Campaign Name"
        v-model="campaignName"
        v-validate="'required'"
        :error-messages="errors.first('campaignName')"
        solo
      />
    </v-container>
    <v-container px-3 pb-0 mt-3 class="green lighten-5 border-light">
      <div class="pb-3 body-2">This is email your leads will be sent to.</div>
      <v-text-field
        required
        name="dispatchTo"
        label="Dispatch Email"
        data-vv-as="Dispatch Email"
        v-model="dispatchTo"
        v-validate="'required|email'"
        :error-messages="errors.first('dispatchTo')"
        solo
      />
    </v-container>
    <v-container px-3 pb-0 class="lighten-5">
      <v-checkbox v-model="shouldCreateLanding" label="Generate Landing Page">
      </v-checkbox>
    </v-container>
  </v-form>
</template>
<script>
export default {
  data() {
    return {
      campaignName: '',
      dispatchTo: '',
      shouldCreateLanding: true
    };
  },
  methods: {
    async submit() {
      const isValid = await this.$validator.validate();
      if (!isValid) {
        return;
      }
      this.$emit("submit", {
        campaignName: this.campaignName,
        dispatchTo: this.dispatchTo,
        shouldCreateLanding: this.shouldCreateLanding
      });
    }
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/CampaignMainInfo.vue